import styled from "styled-components"
import slotmachine from "../assets/images/slot-machine.svg"

export const IconMaquinas = styled.div`
  width: ${props => props.fontSize || "24px"};
  height: ${props => props.fontSize || "24px"};
  background-color: #fff;
  -webkit-mask: url(${slotmachine}) no-repeat center;
  mask: url(${slotmachine}) no-repeat center;
`

export const HiOutlineSlotMachine = ({ size = 18, color = "currentColor" }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 12L7 8V7H4V8H6L4 12M9 12L11 8V7H8V8H10L8 12M13 12L15 8V7H12V8H14L12 12M21 2C19.9 2 19 2.9 19 4C19 4.7 19.4 5.4 20 5.7V17H17V15C17.6 15 18 14.6 18 14V5C18 4.4 17.6 4 17 4H13.2C12.4 2.8 11 2 9.5 2C8 2 6.6 2.8 5.8 4H2C1.4 4 1 4.4 1 5V14C1 14.6 1.4 15 2 15V22H17V19H20C21.1 19 22 18.1 22 17V5.7C22.6 5.4 23 4.7 23 4C23 2.9 22.1 2 21 2ZM3 6H16V13H3V6ZM15 20H4V15H15V20ZM13 19H6V17H13V19Z" />
    </svg>
  );
};